export default "__VITE_ASSET__44fec059__"